<template>
  <lego-modal
    ref="modal"
    :title="monitorInfo.pProductTypeName + ' ' + $t('title.monitoringTargetAdd')"
    :size="1112"
    @closed="close"
  >
    <div class="modal-content-wrap">
      <div class="lego-select-search">
        <lego-dropdown
          v-if="!!monitorInfo.pObjectTypeCode && this.objectTypeList.length > 0"
          v-model="objectTypeCode"
          :items="objectTypeList"
          :width="200"
          readOnly
        />
        <div
          class="lego-text-field-wrapper"
          :style="{
            width:
              !!monitorInfo.pObjectTypeCode && this.objectTypeList.length > 0
                ? 'calc(100% - 210px)'
                : '100%'
          }"
        >
          <lego-text-field
            searchable
            v-model="searchText"
            :placeholder="$t('searchLabel.searchLike', { VPC: $t('searchLabel.monTarget') })"
            counter="100"
            :mutateInput="mutateProductName"
            :isCounter="false"
          />
        </div>
      </div>
      <AddMonitorTargetSubItem
        v-if="isExistSubItem"
        ref="subItem"
        :searchText="searchText"
        :monitorInfo="monitorInfo"
        :objectTypeName="objectTypeName"
        @onCheck="onCheck"
      >
      </AddMonitorTargetSubItem>
      <AddMonitorTargetItem
        v-else
        :searchText="searchText"
        :monitorInfo="monitorInfo"
        @onCheck="onCheck"
      >
      </AddMonitorTargetItem>
      <div class="scpm-drag-wrap">
        <scpm-sub-title
          >{{ $t('page.eventStatus.selectedItem') }}
          <span style="color: var(--blue-with-a-hint-of-purple)"> {{ allCardList.length }}</span>
        </scpm-sub-title>
        <lego-add-list-table
          listTitle
          no-table
          noBoxHeader
          v-model="allCardList"
          @delete="deleteCard"
        >
          <template #listContent="itemProp">
            <div class="badge-text-wrapper">
              <span>{{ itemProp.item.productName }}</span>
              <template v-if="isExistSubItem">
                : <span class="listTargetItem">{{ itemProp.item.objectDisplayName }}</span>
              </template>
              <lego-tooltip bottom hover maxWidth="10">
                {{ productNamePrefix + itemProp.item.productName }}
                <div v-if="isExistSubItem">
                  {{ itemProp.item.objectType ? objectTypeName + ':' : '' }}
                  {{ itemProp.item.objectDisplayName || '' }}
                </div>
              </lego-tooltip>
            </div>
          </template>
        </lego-add-list-table>
      </div>
    </div>
    <template slot="action">
      <lego-button @click="close" medium>{{ $t('button.cancel') }}</lego-button>
      <lego-button @click="confirm" medium main>{{ $t('button.confirm') }}</lego-button>
    </template>
  </lego-modal>
</template>
<script>
import { PREFIX_MAP_PRODUCT_TYPES } from '@/containers/utils/constant.js';
import { checkObjectTypesNonSub } from '@/containers/utils/utils.js';
import AddMonitorTargetItem from '@/containers/performance/AddMonitorTargetItem.vue';
import AddMonitorTargetSubItem from '@/containers/performance/AddMonitorTargetSubItem.vue';
export default {
  name: 'AddMonitorTargetPopup',
  props: {
    monitorInfo: {
      type: Object,
      default: () => {
        return {
          pProductTypeCode: '',
          pProductTypeName: '',
          pProductTypeCodes: [],
          pObjectTypeCode: '',
          pObjectTypeName: ''
        };
      }
    }
  },
  components: {
    AddMonitorTargetItem,
    AddMonitorTargetSubItem
  },
  computed: {
    productNamePrefix() {
      return PREFIX_MAP_PRODUCT_TYPES[this.monitorInfo.pProductTypeCode] || '';
    },
    isExistSubItem() {
      let { pProductTypeCode, pObjectTypeCode } = this.monitorInfo;
      return checkObjectTypesNonSub(pProductTypeCode, pObjectTypeCode);
    }
  },
  data() {
    return {
      objectTypeCode: '',
      searchText: '',
      objectTypeList: [],
      allCardList: [],
      objectTypeName: ''
    };
  },
  created() {
    this.popupInit();
  },
  mounted() {
    this.$refs['modal'].open();
  },
  methods: {
    async popupInit() {
      if (this.monitorInfo.pObjectTypeCode) {
        this.objectTypeList = await this.$http.product.getListProductObjectTypes(
          this.monitorInfo.pProductTypeCode
        );
        this.objectTypeCode = this.monitorInfo.pObjectTypeCode;
        this.objectTypeName = this.objectTypeList.find((o) => o.value === this.objectTypeCode).text;
      }
    },
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm', this.allCardList);
    },
    mutateProductName(value) {
      return value.replace(this.$const.NOT_ALLOWED_REGEX.MORNITORING_NAME, '');
    },
    deleteCard(delType, item) {
      if (this.isExistSubItem) {
        this.$refs.subItem.deleteCard(item);
      }
    },
    onCheck(selectedItems) {
      this.allCardList = selectedItems;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-content-wrap {
  max-width: 1000px;

  .lego-table-wrap {
    padding: 14px 0 0 0;
  }
}
.lego-select-search {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.lego-text-field-wrapper {
  display: inline-block;
}
.modal-cotent-wrap {
  max-width: 1000px;
}
.badge-text-wrapper {
  display: flex;
  align-items: center;
}
::v-deep .listTargetItem {
  display: inline-block;
  color: #364fc7;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
::v-deep .scpmSubTitleContainer .scpmSubTitle {
  font-size: 14px !important;
}
.scpm-drag-wrap {
  padding-top: 20px;
}
::v-deep .added-list-box {
  margin-top: 5px !important;
}
</style>
